import { useEffect, useRef, useState } from 'react'

const SETTINGS_TAB_SKELETON_DURATION_MS = 500

export function useSettingsTabSkeleton(tabKey: string): boolean {
  const [isTabSkeleton, setIsTabSkeleton] = useState(false)
  const [skeletonKey, setSkeletonKey] = useState(0)
  const prevTabRef = useRef(tabKey)

  useEffect(() => {
    if (prevTabRef.current === tabKey) return
    prevTabRef.current = tabKey
    setIsTabSkeleton(true)
    setSkeletonKey((key) => key + 1)
  }, [tabKey])

  useEffect(() => {
    if (!isTabSkeleton) return
    const timer = window.setTimeout(() => {
      setIsTabSkeleton(false)
    }, SETTINGS_TAB_SKELETON_DURATION_MS)
    return () => window.clearTimeout(timer)
  }, [isTabSkeleton, skeletonKey])

  return isTabSkeleton
}
